import { fromPairs } from 'lodash';
import { type IExpression } from '../IExpression.ts';
import { type IExpressionType } from '../IExpressionType.ts';
import { AsyncExpressionType } from './async/AsyncExpression.type.ts';
import { ComputedDateExpressionType } from './computed-date/ComputedDateExpression.type.ts';
import { ConditionExpressionType } from './condition/ConditionExpression.type.ts';
import { ConditionGroupExpressionType } from './condition-group/ConditionGroupExpression.type.ts';
import { FunctionExpressionType } from './function/FunctionExpression.type.ts';
import { ReferenceExpressionType } from './reference/ReferenceExpression.type.ts';
import { SubconditionGroupExpressionType } from './subconditions-group/SubconditionsGroupExpression.type.ts';
import { SwitchExpressionType } from './switch-expression/SwitchExpression.type.ts';
import { ValueExpressionType } from './value/ValueExpression.type.ts';

const ExpressionTypes: IExpressionType[] = [
  AsyncExpressionType,
  ConditionExpressionType,
  ConditionGroupExpressionType,
  FunctionExpressionType,
  ReferenceExpressionType,
  SubconditionGroupExpressionType,
  ValueExpressionType,
  SwitchExpressionType,
  ComputedDateExpressionType,
];

export const ExpressionRepository = {
  mappedTypes: fromPairs(ExpressionTypes.map(type => [type.type, type])),
  get<TExpr extends IExpression>(type: TExpr['type']): IExpressionType<TExpr> {
    return this.mappedTypes[type] as unknown as IExpressionType<TExpr>;
  },
};
